import theme, { COLORS, SIZES, FONTS } from './theme'
import images from './images'
import axios from "axios";
//const API_URL = 'http://localhost:5000';
const API_URL = 'https://server.dev.konsensus.tech';
const FORUM_URL = 'https://forum.dev.konsensus.tech';
const APP_URL = 'https://app.dev.konsensus.tech';
const NEM_URL = 'https://dev.nem.co.za';

const AXIOS_CONFIG = {
    headers: {
        'Accept':'application/json',
        'accept': 'application/json',
        'Content-Type':'application/json',
    }
}

async function _retrieveDataLocal(key){
    try {
        const value = await localStorage.getItem('@Konsensus:'+key);
        let value_parsed = JSON.parse(value);
        // check last_login
        let dt = new Date();
        dt.setDate( dt.getDate() - 1 );
        if( value_parsed!==null ) {
            // console.log(new Date(value_parsed.user.last_login).toDateString() + '<' + dt.toDateString());
            return {[key]: value_parsed};
        }else{
            // console.log("weird:" + value_parsed);
            return false;
        }
    } catch (error) {
        // Error retrieving data
        console.log("Error:" + error);
        return false;
    }
};

async function _storeData(key, value){
    try {
        await localStorage.setItem('@Konsensus:'+key, JSON.stringify(value));
        // console.log("Stored " + key + " value: "+value);
    } catch (error) {
        // Error saving data
        console.log("Error Stored " + error);
    }
};

async function _removeItem(key){
    try {
        await localStorage.removeItem('@Konsensus:'+key);
        // console.log("Stored " + key + " value: "+value);
    } catch (error) {
        // Error saving data
        console.log("Error removing " + error);
    }
};

export default {
    API_URL,
    FORUM_URL,
    APP_URL,
    NEM_URL,
    AXIOS_CONFIG,
    _retrieveDataLocal,
    _storeData,
};
export { images, theme, COLORS, SIZES, FONTS }

